import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { btnPrimary } from "@/lib/ui";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-navy" data-testid="admin-login">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden">
        <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-brandgreen/10 blur-3xl" />
        <Logo variant="light" />
        <div className="relative">
          <h1 className="font-heading text-4xl font-bold text-white leading-tight">
            Lead & booking dashboard
          </h1>
          <p className="mt-4 text-white/70 max-w-md leading-relaxed">
            Manage quote requests, track leads through every stage, view customer photos and keep your bookings
            organised — all in one secure place.
          </p>
          <div className="mt-8 flex items-center gap-2 text-sm text-white/60">
            <ShieldCheck className="w-4 h-4 text-brandgreen-light" /> Private &amp; secure · authorised access only
          </div>
        </div>
        <span className="relative text-xs text-white/40">© {new Date().getFullYear()} JK House Cleaning</span>
      </div>

      <div className="grid place-items-center p-8 bg-neutralbg">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8 flex justify-center"><Logo /></div>
          <div className="rounded-3xl bg-white shadow-xl border border-gray-100 p-8">
            <span className="grid place-items-center w-14 h-14 rounded-2xl bg-navy mx-auto">
              <LogIn className="w-7 h-7 text-brandgreen-light" />
            </span>
            <h2 className="mt-6 font-heading text-2xl font-bold text-navy text-center">Admin sign in</h2>
            <p className="mt-2 text-sm text-gray-500 text-center">
              Sign in with your authorised Google account to access the dashboard.
            </p>
            <button onClick={login} disabled={loading} className={`${btnPrimary} w-full mt-8`} data-testid="google-login-btn">
              <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#ffffff" d="M12 11v2.8h4.6c-.2 1.2-1.4 3.5-4.6 3.5-2.8 0-5-2.3-5-5.1s2.2-5.1 5-5.1c1.6 0 2.6.7 3.2 1.2l2.2-2.1C17.9 4.6 15.2 3.5 12 3.5 6.9 3.5 2.8 7.6 2.8 12.2S6.9 20.9 12 20.9c5.1 0 8.5-3.6 8.5-8.6 0-.6-.1-1-.1-1.4H12z" />
              </svg>
              Continue with Google
            </button>
            <p className="mt-5 text-xs text-gray-400 text-center">
              Only authorised JK House Cleaning accounts can access this area.
            </p>
          </div>
          <a href="/" className="mt-6 flex items-center justify-center gap-1.5 text-sm text-gray-500 hover:text-navy transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to website
          </a>
        </div>
      </div>
    </div>
  );
}
